import React from 'react';
import {useI18n} from '../../i18n/useI18n';
import {useSiteContent} from '../../pages/site/siteContent';
import SiteLink from './SiteLink';
import styles from './styles/SiteFooter.module.css';

const SiteFooter: React.FC = () => {
    const {t} = useI18n();
    const {brandSubtitle, siteNavItems} = useSiteContent();

    return (
        <footer className={styles.footer}>
            <div className={`site-content-width ${styles.top}`}>
                <div className={styles.brandBlock}>
                    <img alt="D-Sense" src="/d-sense.png"
                         style={{width: 44, height: 44, objectFit: 'contain', marginBottom: 14}}/>
                    <strong>D-Sense</strong>
                    <p>{brandSubtitle}</p>
                </div>
                <div className={styles.linkBlock}>
                    <span>{t('site.footer.navigation')}</span>
                    <div className={styles.linkGrid}>
                        {siteNavItems.map(item => (
                            <React.Fragment key={item.label}>
                                <div>
                                    {null == item.path ? (
                                        <span className={styles.navCategory}>{item.label}</span>
                                    ) : (
                                        <SiteLink to={item.path}>{item.label}</SiteLink>
                                    )}
                                </div>
                                <div className={styles.links}>
                                    {item.children?.map(child => (
                                        <SiteLink key={child.path} to={child.path}>{child.label}</SiteLink>
                                    ))}
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className={styles.textBlock}>
                    <span>{t('site.footer.risk')}</span>
                    <p>{t('site.footer.riskText')}</p>
                </div>
            </div>
            <div className={`site-content-width ${styles.bottom}`}>
                <span>{t('site.footer.bottomLeft')}</span>
            </div>
        </footer>
    );
};

export default SiteFooter;
